export default {
    cancel: 'ยกเลิก',
    cannotHaveSharp: 'ห้ามกรอกตัวอักษร #',
    companySetting: 'ตั้งค่าบริษัท',
    congratulations: 'ยินดีด้วย',
    createUserByAdmin: 'สร้างสมาชิกใหม่',
    editUserByAdmin: 'แก้ไขผู้ใช้งาน',
    employeeId: 'รหัสพนักงาน',
    email: 'อีเมล',
    emailIsExceededCharacters: 'อีเมลเกิน 255 ตัวอักษร',
    emailIsRequired: 'กรุณากรอกอีเมล',
    incorrectPhoneNumber: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
    invalidEmailFormat: 'รูปเเบบอีเมลไม่ถูกต้อง',
    prefixThai: 'คำนำหน้าไทย',
    prefixEnglish: 'คำนำหน้าอังกฤษ',
    firstNameThai: 'ชื่อไทย',
    firstNameEnglish: 'ชื่ออังกฤษ',
    lastNameThai: 'นามสกุลไทย',
    lastNameEnglish: 'นามสกุลอังกฤษ',
    password: 'รหัสเข้าใช้',
    permissionType: 'ประเภทสิทธิ',
    profile: 'ข้อมูลส่วนตัว',
    phoneNumber: 'เบอร์โทรศัพท์',
    save: 'บันทึก',
    somethingWrong: 'เกิดข้อผิดพลาด',
    update: 'อัปเดต / แก้ไข',
    username: 'ชื่อเข้าใช้',
    view: 'อ่าน / ดูรายการ',
    thisFieldIsRequired: 'กรุณากรอกข้อมูล',
    thisFieldIsExceededCharacters: 'ข้อความเกิน 255 ตัวอักษร'
}
